import React, { useState } from 'react';
import { Badge, Button, Col, Form, List, Modal, Popconfirm, Space, message } from 'antd';
import { BookyInput, InputType } from '../Forms/BookyInput';
import { BookOutlined, EditOutlined } from '@ant-design/icons';
import { TextService } from '../../Services/TextService';
import { WebApiModelsNote } from '../../Repository/eventbookyapi';
import { MemberService } from '../../Services/MemberService';
import { BookyButton } from '../Buttons/BookyButton';
import { formatDateString } from '../../Helpers/DateHelpers';

export const AddNote = (props: any) => {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const GetText = TextService.GetText;
    const [notes, setNotes] = useState([] as WebApiModelsNote[]);
    const [editingNote, setEditingNote] = useState<WebApiModelsNote | null>(null);
    const [editText, setEditText] = useState("");

    const onCancel = () => {
        form.setFieldValue("groupName", "");
        setOpen(false);
        cancelEdit();
        props.loadMembers();
    };

    const onCreate = async () => {
        try {
            await MemberService.AddNote({
                memberId: props.member.memberId,
                text: form.getFieldValue("text"),
            });

            form.setFieldValue("text", "");
            loadNotes();
        } catch (error) {
            message.warning(GetText("EditMember_ErrorSaving"));
            return;
        }
    }

    const loadNotes = () => {
        MemberService.GetNotes(props.member.memberId).then(result => {
            setNotes(result);
        })
    }

    const deleteNote = (note: WebApiModelsNote) => {
        MemberService.DeleteNote(note.id!).then(result => {
            loadNotes();
        })
    }

    const startEdit = (note: WebApiModelsNote) => {
        setEditingNote(note);
        setEditText(note.text || "");
    }

    const cancelEdit = () => {
        setEditingNote(null);
        setEditText("");
    }

    const saveEdit = async () => {
        if (!editingNote) return;
        try {
            await MemberService.EditNote({
                noteId: editingNote.id,
                text: editText,
            });
            cancelEdit();
            loadNotes();
        } catch (error) {
            message.warning(GetText("EditMember_ErrorSaving"));
        }
    }

    const locale = {
        emptyText: GetText("AddNote_NoNotes")
    }

    return (
        <>
            <Modal
                open={open}
                title={GetText("AddNote_ModalTitle") + " - (" + props.member.uniqueId + ") " + props.member.firstName + " " + props.member.lastName}
                width={700}
                okText={GetText("EditMember_ModalClose")}
                onOk={onCancel}
                onCancel={onCancel}
                cancelButtonProps={{ style: { display: 'none' } }}
            >
                <Form form={form} labelAlign={"left"} labelCol={{ span: 8, offset: 0 }} wrapperCol={{ span: 16 }} >
                    <Col span={17}>
                        <BookyInput type={InputType.multiline} onClick={onCreate} name="text" req placeholder={GetText("AddNote_NoteColumnPlaceHolder")} />
                        <BookyButton
                            type="primary"
                            disabled={props.user.hasOnlyReadRights}
                            fullWidth={false}
                            text={GetText("AddNote_SaveNote")}
                            onClick={onCreate}
                        >
                        </BookyButton>
                    </Col>
                </Form>

                <List
                    locale={locale}
                    itemLayout="horizontal"
                    dataSource={notes}
                    renderItem={(item, index) => (
                        <List.Item extra={
                            <Space>
                                {editingNote?.id !== item.id && (
                                    <Button disabled={props.user.hasOnlyReadRights} size="small" icon={<EditOutlined />} onClick={() => startEdit(item)}>{GetText("AddNote_EditNote")}</Button>
                                )}
                                <Popconfirm
                                    title={GetText("AddNote_DeleteConfirm")}
                                    onConfirm={() => deleteNote(item)}
                                    okText={GetText("Common_Delete")}
                                    cancelText={GetText("Common_Cancel")}
                                >
                                    <Button disabled={props.user.hasOnlyReadRights} size="small">{GetText("Common_Delete")}</Button>
                                </Popconfirm>
                            </Space>
                        }>
                            <List.Item.Meta
                                title={
                                    <span>
                                        {item.createdByName} {formatDateString(item.createdAt!.toString())}
                                        {item.updatedAt && <span style={{ fontStyle: 'italic', color: '#999', marginLeft: 8, fontSize: 12 }}>{GetText("AddNote_Edited")}</span>}
                                    </span>
                                }
                                description={
                                    editingNote?.id === item.id ? (
                                        <div>
                                            <textarea
                                                style={{ width: '100%', minHeight: 60, marginBottom: 8 }}
                                                value={editText}
                                                onChange={(e) => setEditText(e.target.value)}
                                            />
                                            <Space>
                                                <Button type="primary" size="small" onClick={saveEdit}>{GetText("Common_Save")}</Button>
                                                <Button size="small" onClick={cancelEdit}>{GetText("AddNote_CancelEdit")}</Button>
                                            </Space>
                                        </div>
                                    ) : item.text
                                }
                            />
                        </List.Item>
                    )}
                />
            </Modal>


            <Badge color={"blue"} className={props.member.numberOfNotes ? "" : "not-payed"}>
                <BookOutlined
                    style={{ fontSize: "20px" }}
                    type="primary"
                    onClick={() => {
                        setOpen(true);
                        loadNotes();
                    }}
                >
                </BookOutlined>
            </Badge>
        </>
    );
};

export default AddNote;